/**
 *  Kinty / App / Pages / Dashboard / Tabs / Gainers
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *  The Gainers Tab
 *
 */

/** Dependencies */
import React from "react";
import {
  Table,
  TableHead,
  TableHeadRow,
  TableHeadCell,
  TableBody,
  TableRow,
  TableCell,
  SymbolBadge,
  Price,
  Percent,
} from "@kinty-app/ui";
import { useListControllerGetGainers, getSymbolLogoUrl } from "@kinty-app/api";
import Dinero from "dinero.js";

export const Gainers: React.FC = () => {
  const { data } = useListControllerGetGainers({});

  return (
    <Table>
      <TableHead>
        <TableHeadRow>
          <TableHeadCell>Symbol / Name</TableHeadCell>
          <TableHeadCell align="right">Price</TableHeadCell>
          <TableHeadCell align="right">Change</TableHeadCell>
          <TableHeadCell align="right">Change (%)</TableHeadCell>
          <TableHeadCell align="right">Volume</TableHeadCell>
          <TableHeadCell align="right">Market Cap</TableHeadCell>
        </TableHeadRow>
      </TableHead>
      <TableBody>
        {(data || []).map((gainer) => (
          <TableRow key={gainer.symbol}>
            <TableCell>
              <SymbolBadge
                ticker={gainer.symbol}
                name={gainer.companyName}
                image={getSymbolLogoUrl(gainer.symbol)}
              />
            </TableCell>
            <TableCell align="right">
              <Price amount={Math.ceil(gainer.price * 100)} currency="USD" />
            </TableCell>
            <TableCell align="right">
              <Price amount={Math.ceil(gainer.change * 100)} currency="USD" />
            </TableCell>
            <TableCell align="right">
              <Percent amount={gainer.changePercent * 100} />
            </TableCell>
            <TableCell align="right">
              {Dinero({
                amount: gainer.volume * 100,
                currency: "USD",
              }).toFormat("$0,0")}
            </TableCell>
            <TableCell align="right">
              {Dinero({
                amount: gainer.marketCap * 100,
                currency: "USD",
              }).toFormat("$0,0")}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
